import { FAQ as FAQProps } from "@/types/faq/faq.type";
import { FaChevronDown } from "react-icons/fa";
import { FaRegCircleQuestion } from "react-icons/fa6";

export const Faq = ({ faq }: { faq: FAQProps }) => {
  return (
    <details className="group border-b border-gray-700 py-4 ">
      <summary
        className="
          flex items-center justify-between pt-4 pb-2 px-4 w-full text-left group-open:bg-dark-gray group-open:rounded-t-xl text-white cursor-pointer list-none
          transition-all duration-200
          hover:text-primary
          active:scale-[0.98] active:opacity-80
        "
      >
        <p className="flex justify-center items-center gap-2 text-lg font-medium">
          <FaRegCircleQuestion size={26} /> {faq.qns}
        </p>
        <FaChevronDown className="transition-transform duration-300 group-open:rotate-180" />
      </summary>

      <div
        className="
          overflow-hidden  transition-all px-4 group-open:bg-dark-gray group-open:rounded-b-xl duration-500 ease-in-out
          h-0 opacity-0
          group-open:h-fit pt-2 pb-4 group-open:opacity-100
            text-light-text leading-relaxed
        "
      >
        {faq.ans}
      </div>
    </details>
  );
};
